import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarServicedesk from '@atlassian/jira-navigation-apps-sidebar-servicedesk/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getConsolidationStateResource } from '@atlassian/jira-router-resources-eoc-tenant-info/src/services/index.tsx';
import { getServiceDeskSettingsResources } from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import { projectSettingsServicedeskChannelsEmailNextGenRoute } from '@atlassian/jira-router-routes-project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskChannelsEmailNextGenRoute.tsx';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import { serviceDeskEmailNextGenRedirect } from './ui/service-desk-email-next-gen-redirect/index.tsx';
import { LazyProjectSettingsServiceDeskEmail } from './ui/service-desk-email/index.tsx';

export const projectSettingsServicedeskChannelsEmailNextGenRouteEntry = createEntry(
	projectSettingsServicedeskChannelsEmailNextGenRoute,

	() => ({
		group: 'project-settings-servicedesk',
		component: serviceDeskEmailNextGenRedirect,
		layout: serviceProjectLayout,

		navigation: {
			menuId: MENU_ID.PROJECTS,
			sidebar: AsyncSidebarServicedesk,
			sidebarId: SIDEBAR_ID.PROJECT_SETTINGS,
		},

		resources: [...getServiceDeskSettingsResources(), getConsolidationStateResource()],
		forPaint: [LazyAtlassianNavigation, LazyProjectSettingsServiceDeskEmail],

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-project-settings-product-routes-service-desk-entries/src/projectSettingsServicedeskChannelsEmailNextGenRouteEntry.tsx',
				whichExportToUse: 'projectSettingsServicedeskChannelsEmailNextGenRouteEntry',
			},

			enabled: true,
		},
	}),
);
